let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kVX56"), load("9qY9x")]).then(() => parcelRequire('dQKu6'));